module.exports = __webpack_public_path__ + "img/icon_comment_solid.2698a380.svg";